import React, { useState } from "react";
import Navbar from "../components/Nav";
import Footer from "../components/Footer";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "contactMessages"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      setSuccess(true);
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div style={{ minHeight: "100vh", backgroundColor: "#f5f0ea", padding: "50px 20px", fontFamily: "Inter, system-ui, sans-serif" }}>
        <h1 style={{ textAlign: "center", color: "#5b3a29", fontSize: "36px", marginBottom: "40px" }}>📬 Contact Us</h1>
        <div style={{ maxWidth: "1000px", margin: "0 auto", display: "flex", flexWrap: "wrap", gap: "40px" }}>
          {/* Contact Info */}
          <div style={{ flex: "1", minWidth: "300px", backgroundColor: "#fff", borderRadius: "15px", padding: "30px", boxShadow: "0 8px 20px rgba(0,0,0,0.1)", border: "2px solid #d4af37" }}>
            <h2 style={{ color: "#5b3a29", marginBottom: "20px" }}>Our Office</h2>
            <p style={{ margin: "10px 0", fontWeight: "600" }}>🏢 Address:</p>
            <p>123 Legal St., Cairo, Egypt</p>

            <p style={{ margin: "10px 0", fontWeight: "600" }}>📞 Phone:</p>
            <p>+20 123 456 7890</p>

            <p style={{ margin: "10px 0", fontWeight: "600" }}>✉ Email:</p>
            <p>info@yourlawoffice.com</p>

            <p style={{ margin: "10px 0", fontWeight: "600" }}>🕒 Working Hours:</p>
            <p>Sat - Thu: 10:00 AM - 6:00 PM</p>
          </div>

          {/* Contact Form */}
          <div style={{ flex: "1", minWidth: "300px", backgroundColor: "#fff", borderRadius: "15px", padding: "30px", boxShadow: "0 8px 20px rgba(0,0,0,0.1)", border: "2px solid #d4af37" }}>
            <h2 style={{ color: "#5b3a29", marginBottom: "20px" }}>Send Us a Message</h2>
            {success && <p style={{ color: "green", fontWeight: "bold", marginBottom: "15px" }}>✅ Your message has been sent!</p>}
            <form onSubmit={handleSubmit}>
              {["name", "email", "phone"].map((field) => (
                <div key={field} style={{ marginBottom: "15px" }}>
                  <label style={{ display: "block", fontWeight: "600", color: "#5b3a29", marginBottom: "5px" }}>
                    {field === "name" ? "Full Name" : field === "email" ? "Email" : "Phone"}
                  </label>
                  <input
                    type={field === "email" ? "email" : "text"}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    required
                    style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
                  />
                </div>
              ))}

              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontWeight: "600", color: "#5b3a29", marginBottom: "5px" }}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #ccc", minHeight: "100px" }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: "100%",
                  padding: "12px",
                  backgroundColor: "#5b3a29",
                  color: "#fff",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "10px",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  transition: "0.3s",
                }}
                onMouseOver={(e) => !loading && (e.currentTarget.style.backgroundColor = "#d4af37")}
                onMouseOut={(e) => !loading && (e.currentTarget.style.backgroundColor = "#5b3a29")}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
